import type {Preview} from '@storybook/react'
import {withThemeProvider, toolbarTypes} from '../src/utils/storybook-utils/withThemeProvider'

const preview: Preview = {
  globalTypes: toolbarTypes,
  decorators: [
    withThemeProvider // Custom theme provider decorator
  ],
  parameters: {
    actions: {argTypesRegex: '^on[A-Z].*'},
    docs: {source: {state: 'open'}},
    controls: {
      hideNoControlsWarning: true,
      expanded: true,
      matchers: {
        color: /(background|color)$/i,
        date: /Date$/i
      }
    },
    features: {
      storyStoreV7: true
    },
    options: {
      storySort: {
        method: 'alphabetical',
        order: ['Fuegokit - React', 'Welcome', 'Design tokens', 'Components', 'Primitives', 'Patterns', 'Behaviors']
      }
    }
  }
}

export default preview
